import React from 'react';

import type { CircularProgressProps } from '@mui/material';
import { Box, CircularProgress } from '@mui/material';

import type { SxProp } from 'src/types/mui';
import { composeSx } from 'src/utils/styles';

interface FullscreenLoaderProps {
  size?: CircularProgressProps['size'];
  sx?: SxProp;
}

export const FullscreenLoader: React.FC<FullscreenLoaderProps> = ({ size = 100, sx }) => {
  return (
    <Box sx={composeSx(fullscreenLoaderStyles, sx)}>
      <CircularProgress size={size} color="secondary" />
    </Box>
  );
};

const fullscreenLoaderStyles: SxProp = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexFlow: 'column',
  height: '100%',
  p: 5,
};
